import { render, staticRenderFns } from "./ProductMainFields.vue?vue&type=template&id=b8e5d0c2&"
import script from "./ProductMainFields.vue?vue&type=script&lang=js&"
export * from "./ProductMainFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports